import { useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useCallback } from 'react';

/**
 * Composable hook for managing document list cache.
 *
 * Handles `[documents, ...]` queries (paginated lists on pages).
 */
export const useDocumentListCacheManager = () => {
  const queryClient = useQueryClient();

  /**
   * Invalidate all document list queries.
   */
  const invalidateList = useCallback(async () => {
    await queryClient.invalidateQueries({
      predicate: query => {
        const [key] = query.queryKey as [unknown];
        return key === API_QUERY_KEYS.documents;
      },
    });
  }, [queryClient]);

  return { invalidateList };
};
